/* eslint-disable max-lines */
import React from "react";
// TODO: remove once IE11 support deprecated
import "babel-polyfill"; // IE bug fix
import { Switch, Route, BrowserRouter, Redirect } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import { QueryClientProvider } from "react-query";

import { config } from "@fortawesome/fontawesome-svg-core"
import { FetchProfile } from "./profile/FetchProfile";
import { FeatureFlagProvider } from "./contexts/FeatureFlagContext";
import { queryClient } from "./lib/queryClient";
import {
  Applications,
  ForgottenPassword,
  Login,
  LoginWithBreathe,
  AssociateSoftwareToken,
  ChangePassword,
  AccountNotConnected,
  MicrosoftCallback,
  GoogleCallback,
  SetNewPassword,
  VerifyTwoFactor,
} from "./pages";
import { Layout } from "./components";
import { FetchTokens } from "./oauth/FetchTokens";

import "@fortawesome/fontawesome-svg-core/styles.css"

config.autoAddCss = false


const App = () => {
  const isAuthenticated = useStoreState((state) => state.isAuthenticated);
  const profile = useStoreState((state) => state.profile);

  return (
    <QueryClientProvider client={queryClient}>
      <FeatureFlagProvider>
        {isAuthenticated && <FetchProfile />}
        <BrowserRouter>
          <Switch>
            <Route path="/login" render={() => <Login />} />
            <Route path="/forgotten-password" render={() => <ForgottenPassword />} />
            <Route path="/set-new-password" render={() => <SetNewPassword />} />
            <Route path="/verify-2fa" render={() => <VerifyTwoFactor />} />
            <Route
              path="/applications"
              render={() => {
                return isAuthenticated ? (
                  <Applications />
                ) : (
                  <Redirect to="/login" />
                );
              }}
            />
            <Route
              path="/oauth/authorize"
              render={() => {
                return (
                  <Layout>
                    <div
                      className="w-full max-w-500 rounded-md bg-white relative mb-4 pt-10 box-shadow"
                      role="main"
                    >
                      <img
                        alt="companyLogo"
                        src="/design/images/breathe_icon.svg"
                        className="mx-auto h-16 w-auto"
                      />
                      <LoginWithBreathe />
                    </div>
                  </Layout>
                );
                }}
            />
            <Route
              path="/oauth/authorize-callback"
              render={(match) => {
                  const code = match.location.search.replace("?code=", "");
                return (
                  <Layout>
                    <div
                      className="w-full max-w-500 rounded-md bg-white relative mb-4 pt-10 box-shadow"
                      role="main"
                    >
                      <img
                        alt="companyLogo"
                        src="/design/images/breathe_icon.svg"
                        className="mx-auto h-16 w-auto"
                      />
                      <FetchTokens code={code} />
                    </div>
                  </Layout>
                );
                }}
            />
            <Route
              path="/associate-software-token"
              render={() => {
                return (
                  <Layout>
                    <div
                      className="w-full max-w-500 rounded-md bg-white relative mb-4 pt-10 box-shadow"
                      role="main"
                    >
                      <img
                        alt="companyLogo"
                        src="/design/images/breathe_icon.svg"
                        className="mx-auto h-16 w-auto"
                      />
                      <AssociateSoftwareToken email={profile.email} />
                    </div>
                  </Layout>
                );
                }}
            />
            <Route path="/account-not-connected" render={() => <AccountNotConnected />} />
            <Route path="/microsoft/callback" render={() => <MicrosoftCallback />} />
            <Route path="/google/callback" render={() => <GoogleCallback />} />
            <Route
              path="/change-password"
              render={() => {
                  return isAuthenticated ? (
                    <Layout>
                      <div
                        className="w-full max-w-500 rounded-md bg-white relative mb-4 pt-10 box-shadow"
                        role="main"
                      >
                        <img
                          alt="companyLogo"
                          src="/design/images/breathe_icon.svg"
                          className="mx-auto h-16 w-auto"
                        />
                        <ChangePassword />
                      </div>
                    </Layout>
                  ) : (
                    <Redirect to="/login" />
                  );
                }}
            />

            <Redirect to="/login" />
          </Switch>
        </BrowserRouter>
      </FeatureFlagProvider>
    </QueryClientProvider>
  );
};

export default App;
